import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { XInfoLabel, XMediaFn } from '@/components/xqxc_ui';
import model from '@/reducers/system/operation/model';
import { XTitle } from '@/components/xqxc_ui';
import moment from 'moment';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const QualificationInfo = ({
    setBreadcrumbPaths,
    match,
    getSystemOperationInfo,
    systemOperationInfo: {
        companyBaseInfo: {
            enterpriseName = '',
            businessLicenseNo = '',
            expireTime = '',
            businessLicenseImgUrl = '',
        } = {}
    } = {}
}) => {

    useEffect(() => {
        getSystemOperationInfo();
        setBreadcrumbPaths(match); // 自动识别面包屑
    }, []);

    const container = {
        width: '100%',
        height: '100%',
        padding: '20px'
    };

    const infoStyle = {
        paddingLeft: '20px'
    };

    return <div style={container}>
        <XTitle style={{ marginBottom: '10px' }} label='经营资质' />
        <Row style={{ marginBottom: '20px' }}>
            <Col span={8}>
                <XInfoLabel style={infoStyle} label='企业名称：' value={enterpriseName} />
            </Col>
            <Col span={8}>
                <XInfoLabel style={infoStyle} label='营业执照号：' value={businessLicenseNo} />
            </Col>
            <Col span={8}>
                <XInfoLabel style={infoStyle} label='证照有效截止日期：' value={expireTime ? moment(expireTime).format('YYYY-MM-DD') : ''} />
            </Col>
            <Col span={24}>
                <div style={{ display: 'flex', marginTop: '10px', ...infoStyle }}>
                    <p style={{ color: '#999999' }}>营业执照照片：</p>
                    <XMediaFn dataSource={businessLicenseImgUrl} />
                </div>
            </Col>
        </Row>
    </div>;
};

QualificationInfo.propTypes = {
    getSystemOperationInfo: PropTypes.func,
    systemOperationInfo: PropTypes.object,
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

export default connect((state) => ({
    systemOperationInfo: state.systemOperation.systemOperationInfo,
}), {
    setBreadcrumbPaths,
    ...model.actions
})(QualificationInfo);